// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__ZL-hP","fill":"Tabs_fill__uv1H9","divider":"Tabs_divider__zTJU6"};